import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\AdminPanel\WebhookDeliveriesController::index
* @see app/Http/Controllers/AdminPanel/WebhookDeliveriesController.php:27
* @route '/admin-panel/webhook-deliveries'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/admin-panel/webhook-deliveries',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\AdminPanel\WebhookDeliveriesController::index
* @see app/Http/Controllers/AdminPanel/WebhookDeliveriesController.php:27
* @route '/admin-panel/webhook-deliveries'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\AdminPanel\WebhookDeliveriesController::index
* @see app/Http/Controllers/AdminPanel/WebhookDeliveriesController.php:27
* @route '/admin-panel/webhook-deliveries'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\AdminPanel\WebhookDeliveriesController::index
* @see app/Http/Controllers/AdminPanel/WebhookDeliveriesController.php:27
* @route '/admin-panel/webhook-deliveries'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\AdminPanel\WebhookDeliveriesController::index
* @see app/Http/Controllers/AdminPanel/WebhookDeliveriesController.php:27
* @route '/admin-panel/webhook-deliveries'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\AdminPanel\WebhookDeliveriesController::index
* @see app/Http/Controllers/AdminPanel/WebhookDeliveriesController.php:27
* @route '/admin-panel/webhook-deliveries'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\AdminPanel\WebhookDeliveriesController::index
* @see app/Http/Controllers/AdminPanel/WebhookDeliveriesController.php:27
* @route '/admin-panel/webhook-deliveries'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Http\Controllers\AdminPanel\WebhookDeliveriesController::replay
* @see app/Http/Controllers/AdminPanel/WebhookDeliveriesController.php:56
* @route '/admin-panel/webhook-deliveries/{delivery}/replay'
*/
export const replay = (args: { delivery: string | { id: string } } | [delivery: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: replay.url(args, options),
    method: 'post',
})

replay.definition = {
    methods: ["post"],
    url: '/admin-panel/webhook-deliveries/{delivery}/replay',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\AdminPanel\WebhookDeliveriesController::replay
* @see app/Http/Controllers/AdminPanel/WebhookDeliveriesController.php:56
* @route '/admin-panel/webhook-deliveries/{delivery}/replay'
*/
replay.url = (args: { delivery: string | { id: string } } | [delivery: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { delivery: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { delivery: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            delivery: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        delivery: typeof args.delivery === 'object'
        ? args.delivery.id
        : args.delivery,
    }

    return replay.definition.url
            .replace('{delivery}', parsedArgs.delivery.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\AdminPanel\WebhookDeliveriesController::replay
* @see app/Http/Controllers/AdminPanel/WebhookDeliveriesController.php:56
* @route '/admin-panel/webhook-deliveries/{delivery}/replay'
*/
replay.post = (args: { delivery: string | { id: string } } | [delivery: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: replay.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\AdminPanel\WebhookDeliveriesController::replay
* @see app/Http/Controllers/AdminPanel/WebhookDeliveriesController.php:56
* @route '/admin-panel/webhook-deliveries/{delivery}/replay'
*/
const replayForm = (args: { delivery: string | { id: string } } | [delivery: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: replay.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\AdminPanel\WebhookDeliveriesController::replay
* @see app/Http/Controllers/AdminPanel/WebhookDeliveriesController.php:56
* @route '/admin-panel/webhook-deliveries/{delivery}/replay'
*/
replayForm.post = (args: { delivery: string | { id: string } } | [delivery: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: replay.url(args, options),
    method: 'post',
})

replay.form = replayForm

const webhookDeliveries = {
    index: Object.assign(index, index),
    replay: Object.assign(replay, replay),
}

export default webhookDeliveries